"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _excluded = ["color", "size", "className", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var MoveIcon = function MoveIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5 6.707L3.707 8H8V3.707L6.707 5 6 4.293l2.5-2.5 2.5 2.5-.707.707L9 3.707V8h4.293L12 6.707 12.707 6l2.5 2.5-2.5 2.5-.707-.707L13.293 9H9v4.293L10.293 12l.707.707-2.5 2.5-2.5-2.5.707-.707L8 13.293V9H3.707L5 10.293 4.293 11l-2.5-2.5 2.5-2.5z"
    }));
  }

  if (size <= 24) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M19.354 9.646l-.708.708L20.293 12H13V4.707l1.64 1.64.707-.707L12.5 2.793 9.653 5.64l.707.707L12 4.707V12H4.707l1.647-1.646-.708-.708-2.847 2.848 2.847 2.847.708-.707L4.72 13H12v7.28l-1.64-1.64-.707.707 2.847 2.847 2.847-2.847-.707-.707L13 20.28V13h7.28l-1.634 1.634.708.707 2.847-2.847-2.847-2.848z"
    }));
  }

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    className: classes
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.66 20.354L2.807 16.5l3.853-3.854.707.707L4.721 16H16V4.707l-2.646 2.647-.707-.707L16.5 2.793l3.854 3.854-.707.707L17 4.707V16h11.28l-2.647-2.646.707-.707 3.853 3.853-3.853 3.854-.707-.707L28.279 17H17v11.293l2.646-2.646.707.707-3.853 3.853-3.854-3.854.707-.707L16 28.293V17H4.72l2.647 2.646z"
  }));
};

var _default = MoveIcon;
exports["default"] = _default;